import * as React from 'react'

import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import { EmployeeFilterOptionFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import { type Users } from 'modules/core/store/collections/users'

import { type Employees } from 'modules/employees/store/collections/employees'

type NameWithAvatarProps = {
  name: string
  avatarUrl?: string
}

const NameWithAvatar = ({ name, avatarUrl }: NameWithAvatarProps) => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center">
      <Avatar label={name} url={avatarUrl} size="s32" />
      <Text.Normal ellipsis size="300">
        {name}
      </Text.Normal>
    </Box>
  )
}

export const makeEmployeeOptions = (
  employees: Employees | EmployeeFilterOptionFragment[],
  users: Users
) =>
  employees.map((employee) => {
    let name
    let avatar

    if ('access' in employee) {
      name = employee.fullName
      avatar = employee.access?.avatar
    } else {
      const user = users.get(employee.attributes.access_id)
      if (!user) {
        throw new Error(`User not found for employee ${employee.id}`)
      }
      name = user.fullName()
      avatar = user.avatar
    }

    return {
      label: name,
      value: employee.id,
      component: <NameWithAvatar name={name} avatarUrl={buildUrl(avatar)} />,
    }
  })
